
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/remote-award-win-2024",
      function () {
        return require("private-next-pages/blog/remote-award-win-2024.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/remote-award-win-2024"])
      });
    }
  